module.exports = __webpack_public_path__ + "img/faldas.2879e512.jpg";